import { com } from '@eidu/form'
import entityApiUrl from '../entity/baseUrl'
import requireAuthContext from '../authorization/requireAuthContext'
import SemanticLinkId = com.eidu.sharedlib.entity.analytics.SemanticLinkId

type DeleteSemanticLinkParameters = {
  semanticLinkId: SemanticLinkId
}

const deleteSemanticLink = async ({ semanticLinkId }: DeleteSemanticLinkParameters): Promise<void> => {
  const authContext = await requireAuthContext()
  return fetch(`${entityApiUrl}/organizations/${authContext.organizationId}/semantic-links/${semanticLinkId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${authContext.accessToken}`,
    },
  }).then(async (response) => {
    switch (response.status) {
      case 200:
        return
      case 404:
        console.warn(`Got status ${response.status} from deleteSemanticLink endpoint`)
        throw Error(`Semantic link not found: ${semanticLinkId}`)
      default:
        throw Error(`Unexpected response code ${response.status} from deleteSemanticLink endpoint`)
    }
  })
}

export default deleteSemanticLink
